export default __webpack_public_path__ + "static/media/Eye-whitebg.c407e643.svg";